
export default {
  props: {
    items: {
      type: Array,
      default: () => {
        return [
          {
            title: "Création graphique et rédaction des contenus",
            text: "Votre site web à la hauteur de vos ambitions.",
          },
          // {
          //   title: "Mise en place d’une stratégie de référencement",
          //   text: "Bien référencé sur Google pour booster votre visibilité.",
          // },
          {
            title: "Version mobile et tablette",
            text: "Accessible partout et à toute heure.",
          },
          {
            title: "Réservation de votre nom de domaine",
            text: "Imposez votre identité avec un www qui fait rêver.",
          },
          {
            title: "Hébergement, maintenance et sécurisation sur nos serveurs",
            text: "La facilité et la sécurité en un tour de main.",
          },
        ];
      },
    },
    alternative: {
      type: Boolean,
      default: false,
    },
  },
};
